module.exports = __webpack_public_path__ + "assets/84f6aacfb1713612e00ded99778a1802.png";